/**
 * @generated SignedSource<<5bf4974439204488ccc1e748256f03b5>>
 * @relayHash 4ab6c6301f65cfdb5f37fc4de8793673
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e482011b2f91be6332bc574dc8ace1cfb78fe9b5fee981021e4afb97895adb73

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFeaturesPlansSettingsQuery } from './uiFeaturesPlansSettingsQuery.graphql';

const node: PreloadableConcreteRequest<uiFeaturesPlansSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e482011b2f91be6332bc574dc8ace1cfb78fe9b5fee981021e4afb97895adb73",
    "metadata": {},
    "name": "uiFeaturesPlansSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
